import * as z from 'zod'

const payPalCallbackParamsZ = z.object({
  bookingId: z.string(),
  token: z.string(),
  payerId: z.string(),
})
export type PayPalCallbackParams = z.infer<typeof payPalCallbackParamsZ>

const payPalCallbackServiceOutputZ = z.object({
  location: z.string().optional(),
  taskId: z.string().optional(),
})
export type PayPalCallbackServiceOutput = z.infer<
  typeof payPalCallbackServiceOutputZ
>

export const paypalCallbackEndpoint = z
  .function()
  .args(payPalCallbackParamsZ)
  .returns(z.promise(payPalCallbackServiceOutputZ))
